<template>
  <div
    @click="lockToggleHandler"
    class="ag-cell-label-container"
    role="presentation"
  >
    <span
      ref="eMenu"
      class="ag-header-icon ag-header-cell-menu-button"
    ></span>
    <div
      ref="eLabel"
      class="ag-header-cell-label"
      role="presentation"
    >
      <span
        v-if="locked"
        class="material-icons-outlined"
        title="Click here to unlock all"
        >{{ 'lock' }}</span
      >
      <span
        v-if="!locked"
        class="material-icons-outlined"
        title="Click here to lock all"
        >{{ 'lock_open' }}</span
      >
      <span
        ref="eSortOrder"
        class="ag-header-icon ag-sort-order"
      ></span>
      <span
        ref="eSortAsc"
        class="ag-header-icon ag-sort-ascending-icon"
      ></span>
      <span
        ref="eSortDesc"
        class="ag-header-icon ag-sort-descending-icon"
      ></span>
      <span
        ref="eSortNone"
        class="ag-header-icon ag-sort-none-icon"
      ></span>
      <span
        ref="eText"
        class="ag-header-cell-text"
        role="columnheader"
      ></span>
      <span
        ref="eFilter"
        class="ag-header-icon ag-filter-icon"
      ></span>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { ref, toRefs } from 'vue';
  import { ExperianLockHeaderParams } from '@/app/shared/types/grid-cells/experian-lock-header-params.interface';
  import { AtbError } from '@/app/shared/types/errors/error.interface';
  import { useI18n } from 'vue-i18n';
  import { useAlertStore } from '@/app/shared/stores/alert-store';
  import { Motif } from '@/app/shared/enums/motif-enum';

  interface ExperianLockHeaderColumnProps {
    params: ExperianLockHeaderParams;
  }
  const props = defineProps<ExperianLockHeaderColumnProps>();

  const { params } = toRefs(props);
  const locked = ref(false);
  const { t } = useI18n();
  const alertStore = useAlertStore();

  const lockToggleHandler = async () => {
    if (!locked.value) {
      try {
        await params.value.lockAll();
        locked.value = !locked.value;
        params.value?.api.refreshInfiniteCache();
      } catch (e) {
        const errorResponse = e as AtbError;
        alertStore.showNotification(
          errorResponse?.errors?.[0].error ||
            'Unkown error returned from server',
          t(`${params.value.entity}AlertTitle`),
          Motif.ERROR
        );
      }
    } else {
      if (params.value.areEntitiesOpen()) {
        alertStore.showNotification(
          t(`${params.value.entity}OpenError`),
          t(`${params.value.entity}AlertTitle`),
          Motif.ERROR
        );
      } else {
        try {
          await params.value.unlockAll();
          locked.value = !locked.value;
          params.value?.api.refreshInfiniteCache();
        } catch (e) {
          const errorResponse = e as AtbError;
          alertStore.showNotification(
            errorResponse?.errors?.[0].error ||
              'Unkown error returned from server',
            t(`${params.value.entity}AlertTitle`),
            Motif.ERROR
          );
        }
      }
    }
  };
</script>

<style scoped></style>
